import Instance from "../../../../Axios";

// New Actions for the app

const GetDefaultNotifyEmailsWP = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/emailsDefault`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({
        type: "GET_DEFAULT_NOTIFY_EMAILS_WP",
        payload: data.yData,
      });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetDefaultNotifyEmailsWP;